// extracted by mini-css-extract-plugin
export default {"refreshEnergyImage":"styles_refreshEnergyImage__60Dtj","shake":"styles_shake__xrVTz","marker":"styles_marker__cb2nG"};